//------------- STYLES IMPORTS ------------//
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
//------------- ROUTER IMPORT ------------//
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { useRef } from "react";

//---------- COMPONENT IMPORTS ---------//
import ChangePassword from "./components/Screens/Auth/changePassword";
import ForgetPassword from "./components/Screens/Auth/forgotPassword";
import SplashOne from "./components/Screens/intro/splashOne";
import Login from "./components/Screens/Auth/login";
import ResetPassword from "./components/Screens/Auth/resetPassword";
import SplashTwo from "./components/Screens/intro/splashTwo";
import SplashThree from "./components/Screens/intro/splashThree";
import { LayoutOne, NoHeaderFooter } from "./components/Layout";
import Dashboard from "./components/Screens/CommanScreens/Dashboard";
import Rooms from "./components/Screens/CommanScreens/Rooms";

import MyProfile from "./components/Screens/Nurses/MyProfile";

import EditProfile from "./components/Screens/Nurses/EditProfile";

import PatientList from "./components/Screens/Patient/PatientList";
import PatientProfile from "./components/Screens/Patient/PatientProfile";
import PatientDetails from "./components/Screens/Patient/PatientDetails";
import MyTaskDetails from "./components/Screens/CommanScreens/MyTaskDetails";
import MyTasks from "./components/Screens/CommanScreens/MyTasks";
import AssignTask from "./components/Screens/CommanScreens/AssignTask";
import AddHospital from "./components/Screens/SuperAdmin/HospitalManage/AddHospital";
import HospitalDetails from "./components/Screens/SuperAdmin/HospitalManage/HospitalDetail";
import RoleList from "./components/Screens/SuperAdmin/RoleManage/RoleList";
import AddRole from "./components/Screens/SuperAdmin/RoleManage/AddRole";
import { ToastContainer } from "react-toastify";
import HospitalListingData from "./components/Screens/SuperAdmin/HospitalManage/HospitalListing_Data";
import TaskList from "./components/Screens/SuperAdmin/TaskManage/TaskList";
import StaffDetail from "./components/Screens/SuperAdmin/StaffManage/StaffDetail";
import AddStaff from "./components/Screens/SuperAdmin/StaffManage/AddStaff";
import AddPatient from "./components/Screens/SuperAdmin/PatientManage/AddPatient";
import ManagePatientList from "./components/Screens/SuperAdmin/PatientManage/ManagePatientList";
import DashboardSuperAdmin from "./components/Screens/SuperAdmin/Dashboard/Dashboard";
import StaffList from "./components/Screens/SuperAdmin/StaffManage/StaffList";
import RoleDetail from "./components/Screens/SuperAdmin/RoleManage/RoleDetail";
import SearchScreen from "./components/Screens/CommanScreens/SearchScreens";
import EmailVerification from "./components/Screens/Auth/emailVerification";

function App() {
    //const windowWidth = useRef(window.innerWidth);
    const windowHeight = useRef(window.innerHeight);

    // console.log('width: ', windowWidth.current);
    //console.log('height: ', windowHeight.current);

    return (
        <div>
            <style>
                {`.hospital_wrapper {
            min-height: ${windowHeight.current}px
            }`}
            </style>
            <div className="hospital_wrapper">
                <Router>
                    <Routes>
                        <Route element={<NoHeaderFooter />}>
                            <Route path="/" element={<SplashOne />} />
                            <Route path="/welcome" element={<SplashTwo />} />
                            <Route path="/easy-use" element={<SplashThree />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/Forget-Password" element={<ForgetPassword />} />
                            <Route path="/reset-password" element={<ResetPassword />} />
                            <Route path="/email-verification" element={<EmailVerification />} />
                            <Route path="/change-password" element={<ChangePassword />} />
                            <Route path="/patient-list" element={<PatientList />} />
                            <Route path="/patient-profile" element={<PatientProfile />} />
                        </Route>
                        <Route element={<LayoutOne />}>
                            <Route path="/dashboard" element={<Dashboard />} />
                            <Route path="/rooms" element={<Rooms />} />
                            <Route path="/myprofile" element={<MyProfile />} />
                            <Route path="/editprofile" element={<EditProfile />} />
                            <Route path="/patientDetails" element={<PatientDetails />} />
                            <Route path="/myTasks" element={<MyTasks />} />
                            <Route path="/myTaskDetails" element={<MyTaskDetails />} />
                            <Route path="/assignTask" element={<AssignTask />} />
                            <Route path="/add-hospital" element={<AddHospital />} />
                            <Route path="/hospital-detail" element={<HospitalDetails />} />
                            {/* <Route path="/hospital-list" element={<HospitalList />} /> */}
                            <Route path="/role-list" element={<RoleList />} />
                            <Route path="/add-role" element={<AddRole />} />
                            <Route path="/role-detail" element={<RoleDetail />} />
                            <Route path="/hospital-listing" element={<HospitalListingData />} />
                            <Route path="/add-patient" element={<AddPatient />} />
                            <Route path="/task-list" element={<TaskList />} />
                            <Route path="/staff-detail" element={<StaffDetail />} />
                            <Route path="/add-staff" element={<AddStaff />} />
                            <Route path="/manage-patient-list" element={<ManagePatientList />} />
                            <Route path="/dashboard-superadmin" element={<DashboardSuperAdmin />} />
                            <Route path="/staff-list" element={<StaffList />} />
                            <Route path="/search" element={<SearchScreen />} />
                        </Route>
                    </Routes>
                </Router>
                <ToastContainer
                    position="top-center"
                    hideProgressBar={false}
                    autoClose={false}
                    newestOnTop={true}
                    closeOnClick={false}
                    draggable={false}
                    rtl={false}
                />
            </div>
        </div>
    );
}

export default App;
